import axios from 'axios';
import { getToken } from './auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log error for debugging
    if (error.response) {
      console.log('API Error:', error.response.status, error.config?.url);
    }
    // Don't auto-redirect on 401 - let components handle authentication
    // This prevents redirect loops
    return Promise.reject(error);
  }
);

export default api;